<script>
	import { base } from './utils/base';
	import { Router, Link, Route } from 'svelte-routing';
	import { Icon } from "svelte-hero-icons";
	import Nav from './partials/map_viewer/Nav.svelte';
	import { onMount } from 'svelte';

	// Regular imports
	import LandingHome from './routes/LandingHome.svelte';
	import Home from './routes/Home.svelte';
	import MapViewer from './routes/MapViewer.svelte';
	import DataDetail from './routes/DataDetail.svelte';

	let isMapRoute = false;

	const checkRoute = () => {
		isMapRoute = window.location.pathname.endsWith(`${base}/mapViewer`);
	};

	// Listen to URL changes
	onMount(() => {
		// Check initially
		checkRoute();

		// Listen for route changes
		window.addEventListener('popstate', checkRoute);
		
		// Create a MutationObserver to watch for URL changes
		const observer = new MutationObserver(() => {
			checkRoute();
		});

		// Observe URL changes
		observer.observe(document, {
			subtree: true,
			childList: true
		});

		return () => {
			window.removeEventListener('popstate', checkRoute);
			observer.disconnect();
		};
	});

	// Also check route on each render
	$: {
		checkRoute();
	}
</script>

<Router>
	<div class="flex w-screen bg-gray-100 overflow-auto scrollbar-custom"
	class:h-screen={isMapRoute}
	>
		<div class="flex flex-col flex-grow h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
			<div class="sticky top-0 z-50 bg-gray-100">
				<header class="flex justify-between items-center p-4 shadow bg-white">
					<Link to="{base}/">
						<img class="h-[30px] w-auto cursor-pointer" alt="ICIMOD" 
						  src="https://geoapps.icimod.org/cdn/content/logo/icimod_Blue_2020.svg"/>
					</Link>
				</header>
				<Nav className="p-4" />
			</div>
			<main class="flex-grow pt-1" class:overflow-auto={isMapRoute}>
				<Route path="{base}/" component={LandingHome} />
				<Route path="{base}/datasets" component={Home} />
				<Route path={`${base}/mapViewer`} component={MapViewer} />
				<Route path={`${base}/dataDetail`} component={DataDetail} />
			</main>
		</div>
	</div>
</Router>

<style>
  /* Custom scrollbar styles */
  .scrollbar-custom {
    scrollbar-width: thin;  /* For Firefox */
    scrollbar-color: #CBD5E1 #F3F4F6;  /* For Firefox */
  }

  .scrollbar-custom::-webkit-scrollbar {
    width: 8px;
  }

  .scrollbar-custom::-webkit-scrollbar-track {
    background: #F3F4F6;
  }

  .scrollbar-custom::-webkit-scrollbar-thumb {
    background-color: #CBD5E1;
    border-radius: 4px;
  }

  .scrollbar-custom::-webkit-scrollbar-thumb:hover {
    background-color: #94A3B8;
  }
</style>


